/**
 * 상세·작성 화면 안 카카오 지도의 손놀림 규칙 (2026-11-02 · 사용자 결정: 끌기·확대 가능).
 *
 * ## 휠은 «지도를 눌러 깨운 뒤»에만 확대다
 *
 * 지도는 스크롤되는 모달 안에 있다. 휠을 바로 확대로 받으면 모달을 내리다 포인터가 지도에 얹히는
 * 순간 스크롤을 빼앗긴다. 그래서 눌러야 켜지고, 포인터가 나가거나 바깥을 누르면 꺼진다.
 * 끌기와 +/− 단추는 깨우지 않아도 늘 된다.
 *
 * ## 끌다가 모달 밖에서 놓아도 모달이 안 닫힌다
 *
 * 누른 곳과 뗀 곳이 다르면 브라우저가 click 을 둘의 공통 조상(모달 배경)에 낸다. 배경의
 * `e.target === e.currentTarget` 검사를 그대로 통과해 일정 창이 닫힌다 — 그 click 하나만 삼킨다.
 */
export function attachMapGestures(map: any, root: HTMLElement): () => void {
  let pressedInside = false;

  const wake = () => { pressedInside = true; map.setZoomable(true); };
  const sleep = () => { map.setZoomable(false); };
  const pressOutside = (e: PointerEvent) => {
    if (root.contains(e.target as Node)) return;
    pressedInside = false;
    sleep();
  };
  const swallowStrayClick = (e: MouseEvent) => {
    if (pressedInside && !root.contains(e.target as Node)) e.stopPropagation();
    pressedInside = false;
  };

  map.setDraggable(true);
  sleep();
  root.addEventListener('pointerdown', wake);
  root.addEventListener('pointerleave', sleep);
  document.addEventListener('pointerdown', pressOutside, true);
  window.addEventListener('click', swallowStrayClick, true);
  return () => {
    root.removeEventListener('pointerdown', wake);
    root.removeEventListener('pointerleave', sleep);
    document.removeEventListener('pointerdown', pressOutside, true);
    window.removeEventListener('click', swallowStrayClick, true);
  };
}

/**
 * 응답이 오기 전에 「지도」를 접으면 지도가 크기 0 인 숨은 틀에서 만들어져 범위가 어긋난다
 * (경로 지도는 레벨 14 로 뭉친다). 다시 펴서 틀이 크기를 얻을 때 한 번 맞춘다.
 */
export function fitWhenShown(map: any, el: HTMLElement, fit: () => void): () => void {
  if (el.clientWidth > 0 || typeof ResizeObserver === 'undefined') return () => {};
  const observer = new ResizeObserver(() => {
    if (el.clientWidth === 0) return;
    observer.disconnect();
    map.relayout();
    fit();
  });
  observer.observe(el);
  return () => observer.disconnect();
}
